import { TerminalPre, TerminalColor } from './styles';

const GamesList = (props) => {
  return <div>
      <TerminalPre><TerminalColor color="#ffec27">ananas</TerminalColor> | <TerminalColor color="magenta">shi_ra</TerminalColor> | <TerminalColor color="#00e436">jumpNbump</TerminalColor> | <TerminalColor color="#c070c8">station_ao8</TerminalColor> | <TerminalColor color="#779180">gesusas_shape_garden</TerminalColor> | <TerminalColor color="#3fbbfc">kite</TerminalColor></TerminalPre><br></br>
    </div>;
};

export default GamesList;